<script setup lang="ts">
import {
    faChevronLeft,
    type IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import { type MaybeRefOrGetter } from 'vue';

type NavItem = {
    label: MaybeRefOrGetter<string>;
    subLabel?: string;
    icon: IconDefinition;
    info?: string | undefined;
    infoColor?: string;
    click: () => void;
    private?: 'none' | 'user' | 'organization';
    sheet?: boolean;
};
defineProps<{
    navItems: NavItem[];
}>();
const emit = defineEmits<{
    itemSelect: [item: NavItem];
}>();

const onClick = (item: NavItem) => {
    emit('itemSelect', item);
    setTimeout(() => item.click(), 100);
};
</script>

<template>
    <li
        v-for="item in navItems"
        :key="toValue(item.label)"
        class="nav-item"
        @click="onClick(item)"
    >
        <div class="nav-item-icon-container">
            <mr-icon size="small" :icon="item.icon" color="var(--gray-800)" />
        </div>
        <mr-typography
            size="large"
            class="nav-item-title"
            weight="500"
            color="var(--gray-800)"
        >
            {{ item.label }}
            <mr-typography
                size="small"
                type="span"
                class="sub-label"
                color="var(--gray-700)"
            >
                {{ item.subLabel }}
            </mr-typography>
        </mr-typography>
        <mr-typography
            v-if="item.info"
            size="small"
            weight="700"
            :color="item.infoColor ? item.infoColor : 'var(--green-400)'"
        >
            {{ item.info }}
        </mr-typography>
        <mr-icon
            v-if="item.sheet"
            size="small"
            :icon="faChevronLeft"
            color="var(--gray-800)"
        />
    </li>
</template>

<style lang="scss" scoped>
.nav-item {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    .nav-item-icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 36px;
        width: 36px;
        border-radius: 8px;
        padding: 8px;
        background-color: usePalette($p-cool-gray, $p-200);
    }
    .nav-item-title {
        display: flex;
        align-items: center;
        gap: 4px;
        flex-grow: 1;
    }
}
</style>
